var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.368,
    height: 21.354,
    viewBox: "0 0 19.368 21.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(-3.75 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    "data-name": "Path 3227",
    d: "M6.485,6h13.9a1.985,1.985,0,0,1,1.985,1.985v13.9a1.985,1.985,0,0,1-1.985,1.985H6.485A1.985,1.985,0,0,1,4.5,21.883V7.985A1.985,1.985,0,0,1,6.485,6Z",
    transform: "translate(0 -1.015)",
    fill: "none",
    stroke: "#2b339d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    "data-name": "Path 3228",
    d: "M24,3V6.971",
    transform: "translate(-6.595)",
    fill: "none",
    stroke: "#2b339d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    "data-name": "Path 3229",
    d: "M12,3V6.971",
    transform: "translate(-2.537)",
    fill: "none",
    stroke: "#2b339d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    "data-name": "Path 3230",
    d: "M4.5,15H22.368",
    transform: "translate(0 -4.059)",
    fill: "none",
    stroke: "#2b339d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.10223f9aa1f419d30c9910d80a3e6462.svg";
export { ForwardRef as ReactComponent };